<p-toast position="top-right"></p-toast>
<p-confirmDialog #cdwgprt [style]="{width: '600px'}" key="wg-p-rt-dialog">
  <p-footer>
    <button type="button" pButton accesskey="d" icon="pi-fw fas fa-trash-alt" class="p-button-raised p-button-danger" label="Yes" (click)="cdwgprt.accept()"></button>
    <button type="button" pButton icon="pi pi-times" class="p-button-raised p-button-outlined" label="No" (click)="cdwgprt.reject()"></button>
  </p-footer>
</p-confirmDialog>

<div style="height:100%;display:flex;flex-direction:column;min-height:0;">
  <div style="height:36px" class="text-left">
    <button pButton pRipple label="Configure Roster Type" class="p-button-primary p-ml-3" icon="fas fa-sliders-h" (click)="addItem()"></button>
  </div>

  <div style="flex:1 1 auto;min-height:0; width:100%;">
    <ngx-spinner bdColor="rgba(128, 128, 128, 0.8)"
                 size="default"
                 color="#2f9cf2"
                 type="line-scale-pulse-out"
                 [name]="spinnerName"
                 [fullScreen]="false">

      <p style="color:white" >Loading Data... </p>
    </ngx-spinner>

    <ag-grid-angular
        *ngIf="data.length > 0"
        style="width: 100%; height:100%;"
        class="ag-theme-alpine"
        [rowSelection]="{ mode: 'singleRow', checkboxes: false, enableClickSelection: true }"
        [gridOptions]="gridOptions"
        [context]="context"
        [rowData]="data"
        [columnDefs]="gridHeaders"
        [enterNavigatesVertically]="true"  
        [enterNavigatesVerticallyAfterEdit]="true"        
        (gridReady)="onGridReady($event)"></ag-grid-angular>
  </div>
</div>